import { render, staticRenderFns } from "./suspensionTabel.vue?vue&type=template&id=840bd806&scoped=true&"
import script from "./suspensionTabel.vue?vue&type=script&lang=js&"
export * from "./suspensionTabel.vue?vue&type=script&lang=js&"
import style0 from "./suspensionTabel.vue?vue&type=style&index=0&id=840bd806&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "840bd806",
  null
  
)

export default component.exports